export interface HighlightSegment {
  text: string;
  hit: boolean;
}

/// `value` cut into the runs `re` matches and the runs between them. `re` must
/// be global: it is stepped with `exec`.
export function highlightSegments(
  value: string,
  re: RegExp | null,
): HighlightSegment[] {
  if (!re) return [{ text: value, hit: false }];
  const segments: HighlightSegment[] = [];
  let last = 0;
  re.lastIndex = 0;
  let m: RegExpExecArray | null;
  while ((m = re.exec(value)) !== null) {
    if (m.index > last)
      segments.push({ text: value.slice(last, m.index), hit: false });
    if (m[0]) segments.push({ text: m[0], hit: true });
    last = m.index + m[0].length;
    if (m[0] === "") re.lastIndex++;
  }
  if (last < value.length)
    segments.push({ text: value.slice(last), hit: false });
  return segments.length > 0 ? segments : [{ text: value, hit: false }];
}
